import React from 'react';

const AppIcon = ({ name, size = 20, className = '', strokeWidth = 2 }) => {
  // Simple map for current needs, can be expanded
  const icons = {
    ArrowsRightLeftIcon: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M17 11V3l4 4-4 4" />
        <path d="M7 13v8l-4-4 4-4" />
        <path d="M21 7H3" />
        <path d="M3 17h18" />
      </svg>
    ),
    ChevronUpIcon: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M18 15l-6-6-6 6" />
      </svg>
    ),
    ChevronDownIcon: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    ),
    PlayIcon: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
      >
        <path d="M5 3l14 9-14 9V3z" />
      </svg>
    ),
    ArrowRightIcon: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    ),
  };

  return icons[name] || null;
};

export default AppIcon;
